import React, { useEffect, useState } from 'react'
import { Box } from '@mui/material'
import Slider from '@mui/material/Slider'
import { useActions, useAppSelector } from 'hooks'
import { ranking } from 'store/AIMetricOT/reducerSlice'
import { COLOR } from 'constant'
import { viewType } from 'store/vibrancy/reducerSlice'

export const RangeSlider: React.FC<{
  metricGroupName: string
  isSubSlider?: boolean
  value: number
  onChange: (value: number) => void
  onChangeCommitted?: () => void
  isDisabled: boolean
}> = ({ metricGroupName, isSubSlider = false, value, onChange, onChangeCommitted, isDisabled }) => {
  const currentRanking = useAppSelector(ranking)
  const currentViewType = useAppSelector(viewType)
  const isActive = currentRanking === 'global' || currentViewType === 'slope'
  const boxShadow = '0 3px 1px rgba(0,0,0,0.1),0 4px 8px rgba(0,0,0,0.13),0 0 0 1px rgba(0,0,0,0.02)'
  const thumbSize = 16
  const thumbColor = COLOR.DARK
  const [hovered, setHovered] = useState(false)

  const handleSliderChange = (event: Event, newValue: number | number[]) => {
    onChange(newValue as number)
  }

  const KnotThumb = (text: string, isLow: boolean) => {
    return (
      <Box
        sx={{
          background: '#afafaf',
          position: 'relative',
          zIndex: -1,
          userSelect: 'none',
        }}
      >
        {!isSubSlider && (
          <span className='text-slider' style={{ position: 'absolute', bottom: '8px', right: isLow ? 'unset' : '0px' }}>
            {text}
          </span>
        )}
      </Box>
    )
  }
  function valueLabelFormat(valueLabel: number) {
    return valueLabel / 10
  }
  return (
    <Box sx={{ width: '100%' }}>
      <Box
        sx={{
          position: 'relative',
          display: 'flex',
          width: '100%',
          justifyContent: 'center',
          alignItems: 'center',
        }}
        onMouseOver={() => {
          setHovered(true)
        }}
        onMouseOut={() => {
          setHovered(false)
        }}
      >
        {hovered && KnotThumb('Low', true)}
        <Slider
          valueLabelDisplay='auto'
          valueLabelFormat={valueLabelFormat}
          aria-label='metric'
          defaultValue={value || 50}
          value={value}
          onChange={handleSliderChange}
          onChangeCommitted={onChangeCommitted}
          step={10}
          marks
          min={0}
          max={100}
          disabled={!isActive || isDisabled}
          sx={{
            color: '#afafaf',
            height: 2,
            padding: '15px 0',
            position: 'relative',
            pointerEvents: 'none',
            '& .MuiSlider-thumb': {
              height: thumbSize,
              width: thumbSize,
              pointerEvents: 'all',
              backgroundColor: value === 0 ? COLOR.WHITE : thumbColor,
              border: '1px solid #051b33',
              boxShadow: 'none',
              '&:focus, &:hover, &:active, &.Mui-active': {
                boxShadow: boxShadow,
                '@media (hover: none)': {
                  boxShadow: boxShadow,
                },
              },
            },
            '& .Mui-active': {
              '&:before': {
                display: 'none',
              },
            },
            '& .MuiSlider-valueLabelOpen': {
              display: 'block',
            },
            '& .MuiSlider-track': {
              border: 'none',
              pointerEvents: 'all',
            },
            '& .MuiSlider-rail': {
              opacity: 1,
              backgroundColor: '#afafaf',
            },
            '& .MuiSlider-mark': {
              display: 'none',
              '&.MuiSlider-markActive': {
                opacity: 1,
                backgroundColor: 'currentColor',
              },
            },
          }}
        />
        {hovered && KnotThumb('High', false)}
      </Box>
    </Box>
  )
}
